import { render, staticRenderFns } from "./UserRoleTable.vue?vue&type=template&id=8427981c&scoped=true&"
import script from "./UserRoleTable.vue?vue&type=script&lang=js&"
export * from "./UserRoleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8427981c",
  null
  
)

export default component.exports